import Tooltip from '@mui/material/Tooltip';

export const InfoIconTooltip = ({ isShow, message, isError=false }) => (
  isShow ? (
    <>
      <Tooltip
        title={message}
        arrow
        placement="right"
        leaveDelay={100}
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: 'var(--color-surface-light)',
              color: 'var(--color-content)',
              fontSize: '14px',
              padding: '10px',
              fontFamily: 'inherit',
              '& .MuiTooltip-arrow': {
                color: 'var(--color-surface-light)'
              }
            }
          }
        }}
      >
        <i className={`fa fa-info-circle cursor-pointer p-1 inline-flex justify-center relative z-[1] text-primary! ${isError && 'text-danger'}`} />
      </Tooltip>

    </>
  ) : null
);

